<template>
  <div class="container-fluid" style="padding: 0; min-height:45px; background-color: #ffcc00;">
    <h1>
      There will be a scheduled maintenance affecting UniBit website and the API service on
      <b>August 2nd, 2020 (Sunday)</b> from
      <b>10:00am</b> to
      <b>5:00pm</b> Eastern Time (ET). We apologize for any inconvenience caused.
    </h1>
  </div>
</template>

<script>
export default {
  data() {
    return {
      information: "Service Maintenance Schedule:"
    };
  }
};
</script>


<style scoped>
h1 {
  text-align: center;
  width: 100%;
  padding: 13px;
  font-size: 16px;
  color: black;
  margin: 0px;
}
</style>










// WEBPACK FOOTER //
// src/components/fixed/banner.vue